import { GET_NOTIFICATIONS, GET_COUNT_NOTIFICATION, MARK_AS_READ, MARK_ALL_AS_READ, GET_NOTIFICATION_TYPES } from "@/api/header/header";

const handleRequest = async (apiFunc, commit, mutation, args, emptyValue = []) => {
  try {
    const resp = await apiFunc(args);
    const { httpCode, data } = resp.data;

    if (httpCode === 200) {
      if (data?.data && data?.totalItems !== undefined) {
        commit(mutation, {
          data: data.data,
          total: data.totalItems,
          page: data.page,
          limit: data.limit,
          totalPages: data.totalPages,
        });
      } else {
        commit(mutation, data);
      }
      return data;
    }

    commit(mutation, emptyValue);
    return emptyValue;
  } catch (err) {
    const resp = err?.response?.data;
    if (resp?.httpCode === 404) {
      commit(mutation, emptyValue);
    }
    throw err;
  }
};

const state = {
  notifications: {
    data: [],
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 1,
  },
  notificationCounts: 0,
};

const mutations = {
  setNotifications: (state, payload) => {
    state.notifications = {
      data: payload.data || [],
      total: payload.total || 0,
      page: payload.page || 1,
      limit: payload.limit || 10,
      totalPages: payload.totalPages || 1,
    };
  },
  setNotificationCounts: (state, payload) => (state.notificationCounts = payload),
};

const actions = {
  async getNotifications({ commit }, query) {
    return handleRequest(GET_NOTIFICATIONS, commit, "setNotifications", query, []);
  },

  async getNotificationCounts({ commit }, query) {
    return handleRequest(GET_COUNT_NOTIFICATION, commit, "setNotificationCounts", query, 0);
  },

  async markAsRead(_, id) {
    return MARK_AS_READ(id);
  },

  async markAllAsRead() {
    return MARK_ALL_AS_READ();
  },

  async getNotificationTypes() {
    const types = await GET_NOTIFICATION_TYPES();

    return types?.data?.data;
  },
};

const getters = {
  notifications: (state) => state.notifications,
  notificationCounts: (state) => state.notificationCounts,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
